import { useQuery, useQueryClient } from "@tanstack/react-query";

import type { UserProfile } from "../core/domain/entities/user-profile";
import { useUserApi } from "../hooks/useUserApi";

export const USER_PROFILE_QUERY_KEY = "/user/profile";

export const useQueryUserProfile = () => {
  const { api } = useUserApi();

  return useQuery<UserProfile>({
    queryKey: [USER_PROFILE_QUERY_KEY],
    queryFn: () => {
      return api.user.getUserProfile();
    },
  });
};

export const useInvalidateUserProfile = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [USER_PROFILE_QUERY_KEY],
    });
};
